import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';

const url = process.env.REACT_APP_API_URL;

let connection: HubConnection | null = null;
const listeners = new Map<string, (status: any) => void>();
const latestStatuses = new Map<string, any>();

// export async function initHub() {
//   if (connection) return connection;

//   connection = new HubConnectionBuilder()
//     .withUrl(`${url}/hubs/video-upload`)
//     .withAutomaticReconnect()
//     .build();

//   connection.on("UploadUpdated", (data) => {
//     const cb = listeners.get(data.uploadId);
//     if (cb) cb(data);
//   });

//   connection.start()
//     .then(() => {
//       console.log("📡 UploadHub connected.");
//     })
//     .catch(err => console.error("HubConnection failed:", err));

//   return connection;
// }
let startPromise: Promise<void> | null = null;

export async function initHub() {
  if (!connection) {
    console.info("[UploadHub] creating connection", { url: `${url}/hubs/video-upload` });
    connection = new HubConnectionBuilder()
      .withUrl(`${url}/hubs/video-upload`)
      .withAutomaticReconnect()
      .build();

    connection.on("UploadUpdated", (data) => {
      console.info("[UploadHub] update received", data);
      latestStatuses.set(data.uploadId, data);
      const cb = listeners.get(data.uploadId);
      if (cb) cb(data);
    });

    connection.onreconnected(() => {
      console.info("[UploadHub] reconnected");
      listeners.forEach((_cb, uploadId) => {
        connection!.invoke("JoinUploadGroup", uploadId);
      });
    });

    connection.onreconnecting((error) => {
      console.warn("[UploadHub] reconnecting", error);
    });

    connection.onclose((error) => {
      console.warn("[UploadHub] closed", error);
    });
  }

  if (connection.state === "Connected") {
    return connection;
  }

  if (!startPromise) {
    startPromise = (async () => {
      if (connection!.state === "Disconnected") {
        console.info("[UploadHub] starting connection");
        await connection!.start();
        console.info("[UploadHub] connected");
      }
    })().finally(() => {
      startPromise = null;
    });
  }

  await startPromise;
  return connection;
}



// export function subscribe(uploadId: string, callback: (data: any) => void) {
//   initHub();

//   listeners.set(uploadId, callback);

//   connection?.invoke("JoinUploadGroup", uploadId)
//     .then(() => console.log("➡ Joined upload group:", uploadId))
//     .catch(err => console.error("Join group failed:", err));
// }
export async function subscribe(
  uploadId: string,
  callback: (data: any) => void
) {
  const hub = await initHub();

  console.info("[UploadHub] subscribe", { uploadId });
  listeners.set(uploadId, callback);

  const latest = latestStatuses.get(uploadId);
  if (latest) {
    callback(latest);
  }

  await hub.invoke("JoinUploadGroup", uploadId);
  console.info("[UploadHub] joined group", { uploadId });
}



// export function unsubscribe(uploadId: string) {
//   listeners.delete(uploadId);

//   connection?.invoke("LeaveUploadGroup", uploadId).catch(() => {});
// }
export async function unsubscribe(uploadId: string) {
  console.info("[UploadHub] unsubscribe", { uploadId });
  listeners.delete(uploadId);
  latestStatuses.delete(uploadId);

  if (connection?.state === "Connected") {
    await connection.invoke("LeaveUploadGroup", uploadId);
  }
}
